import httpManager from "@/app/shared/utils/httpManager";

export async function fetchAgentsByQueue(queueId) {
  const url = `/queues/${queueId}/agents/`;
  const response = await httpManager.get(url);
  return response.data?.agents;
}
